import React from 'react';
import Icon from '../../../components/AppIcon';

const FeatureHighlights = () => {
  const features = [
    {
      id: 1,
      icon: 'Brain',
      title: 'AI-Powered Insights',
      description: 'Get intelligent financial recommendations and automated categorization'
    },
    {
      id: 2,
      icon: 'Zap',
      title: 'Real-Time Processing',
      description: 'Instant transaction updates and live financial reporting'
    },
    {
      id: 3,
      icon: 'Shield',
      title: 'Compliance Ready',
      description: 'Automated VAT returns and regulatory compliance management'
    },
    {
      id: 4,
      icon: 'BarChart3',
      title: 'Advanced Analytics',
      description: 'Comprehensive reports with predictive business analytics'
    },
    {
      id: 5,
      icon: 'Smartphone',
      title: 'Mobile Access',
      description: 'Full accounting functionality on any device, anywhere'
    },
    {
      id: 6,
      icon: 'Users',
      title: 'Team Collaboration',
      description: 'Multi-user access with role-based permissions and workflows'
    }
  ];

  return (
    <div className="w-full">
      <div className="text-center mb-8">
        <h3 className="text-2xl font-bold text-foreground mb-3">
          Why Choose AccounTech AI?
        </h3>
        <p className="text-muted-foreground">
          Experience the future of accounting with our comprehensive AI-powered platform
        </p>
      </div>
      
      {/* Feature Cards Grid - 3x2 Layout */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-8">
        {features?.map((feature) => (
          <div
            key={feature?.id}
            className="group p-6 bg-card border border-border rounded-xl hover:shadow-elevated transition-all duration-300 hover:border-primary/30 hover:-translate-y-1 min-h-[140px] flex flex-col"
          >
            <div className="flex items-start space-x-4 flex-grow">
              <div className="w-12 h-12 bg-primary/10 rounded-xl flex items-center justify-center flex-shrink-0 group-hover:bg-primary/20 transition-colors duration-300">
                <Icon name={feature?.icon} size={24} className="text-primary" />
              </div>
              <div className="flex-1 min-w-0">
                <h4 className="font-semibold text-foreground mb-2 text-base leading-tight">
                  {feature?.title}
                </h4>
                <p className="text-sm text-muted-foreground leading-relaxed line-clamp-3">
                  {feature?.description}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Call to Action */}
      <div className="mt-8 p-6 bg-gradient-to-r from-primary/5 to-primary/10 border border-primary/20 rounded-xl text-center">
        <h4 className="font-semibold text-foreground mb-2">
          Ready to Transform Your Accounting?
        </h4>
        <p className="text-sm text-muted-foreground mb-4">
          Join thousands of businesses already using AccounTech AI to streamline their financial operations
        </p>
        <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-sm">
          <div className="flex items-center space-x-2 text-success">
            <Icon name="CheckCircle" size={16} />
            <span>Free 30-day trial</span>
          </div>
          <div className="flex items-center space-x-2 text-success">
            <Icon name="CheckCircle" size={16} />
            <span>No setup fees</span>
          </div>
          <div className="flex items-center space-x-2 text-success">
            <Icon name="CheckCircle" size={16} />
            <span>Cancel anytime</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeatureHighlights;